


































































































































































import { Vue, Component } from 'vue-property-decorator';
import Upload from '../components/Uploader.vue';
import moment from 'moment';
import { getNation, getRegion, save } from '../api';
import { isWeiXin, inAppAlertLogin, WechatLogin } from '@/common/ts/common';
import {
  Field,
  Picker,
  Toast,
  RadioGroup,
  Radio,
  DatetimePicker,
  Area,
} from 'vant';

Vue.use(Field)
  .use(Picker)
  .use(Toast)
  .use(Radio)
  .use(RadioGroup)
  .use(DatetimePicker)
  .use(Area);
@Component({
  components: {
    Upload,
  },
})
export default class Save extends Vue {
  minDate: Date = new Date(1980, 0, 1);
  maxDate: Date = new Date();
  currentDate: Date = new Date();
  radioUrl: string = require('../assets/radio.png');
  radioAct: string = require('../assets/radioAct.png');
  imgUrl: any = [];
  columns: any = [];
  value: string = '';
  dateValue: string = '';
  showDate: boolean = false;
  show: boolean = false;
  areaBoolen: boolean = false;
  area: string = '';
  nation: boolean = false;
  submitInfo: any = {
    cover: '',
    name: '',
    old_name: '',
    certificates_type: '',
    certificates: '',
    sex: '',
    year_date: '',
    year: '',
    nation: '',
    nations: '',
    heights: '',
    weights: '',
    lost_date: '',
    lost_address: '',
    residence: '',
    address: '',
    accent: '',
    explain: '',
    posture: '',
    hair_curly: '',
    hair_color: '',
    blood: '',
    body_disability: '',
    birthmark: '',
    tattoo: '',
    limbs_disability: '',
    intelligence_disability: '',
    mentality: '',
    contacts: '',
    phone: '',
    contacts_address: '',
  };
  info: any = [
    {
      title: '',
      item: [
        {
          text: '请上传照片',
          con: '最多上传9张',
          tip: '请上传照片',
          value: 'cover',
          must: true,
          test: '',
          type: 1, // 上传
        },
        {
          text: '姓名',
          content: '未知请填 无',
          tip: '姓名为必填项',
          value: 'name',
          must: true,
          test: '',
          length: 50,
          type: 2, // 输入框
        },
        {
          text: '曾姓名',
          tip: '',
          value: 'old_name',
          must: false,
          test: '',
          length: 50,
          type: 2,
        },
        {
          text: '证件类型',
          content: ['身份证', '军官证', '护照'],
          tip: '证件类型为必填项',
          value: 'certificates_type',
          must: false,
          test: '',
          type: 3, // 选择框
        },
        {
          text: '证件编号',
          tip: '',
          value: 'certificates',
          must: false,
          test: '',
          length: 300,
          type: 2,
        },
        {
          text: '性别',
          content: ['男', '女'],
          tip: '性别为必填项',
          value: 'sex',
          must: true,
          test: '',
          length: 300,
          type: 8, // 单选框
        },
        {
          text: '出生日期',
          content: '',
          tip: '',
          value: 'year_date',
          must: false,
          test: '',
          type: 5, // 时间选择框
        },
        {
          text: '年龄',
          tip: '年龄为必填项',
          value: 'year',
          must: true,
          test: '',
          length: 10,
          type: 2,
        },
        {
          text: '民族',
          tip: '民族为必填项',
          content: [],
          value: 'nations',
          must: false,
          test: '',
          type: 9,
        },
        {
          text: '身高',
          tip: '身高为必填项',
          content: '厘米',
          value: 'heights',
          must: true,
          test: 'number',
          length: 10,
          type: 2,
        },
        {
          text: '体重',
          tip: '体重为必填项',
          value: 'weights',
          content: '千克',
          length: 10,
          must: true,
          test: 'number',
          type: 2,
        },
        {
          text: '走失日期',
          tip: '走失日期为必填项',
          content: '',
          value: 'lost_date',
          must: true,
          test: '',
          type: 5, // 时间选择框
        },
        {
          text: '走失地点',
          tip: '走失地点为必填项',
          value: 'lost_address',
          content: '',
          length: 300,
          must: true,
          test: '',
          type: 2,
        },
        {
          text: '户籍属地',
          tip: '',
          value: 'residence',
          content: ['男', '女', '女'],
          length: 300,
          must: false,
          test: '',
          type: 7,
        },
        {
          text: '详细地址',
          tip: '',
          value: 'address',
          content: '',
          length: 300,
          must: false,
          test: '',
          type: 2,
        },
        {
          text: '口音',
          tip: '',
          value: 'accent',
          content: '',
          length: 100,
          must: false,
          test: '',
          type: 2,
        },
        {
          text: '情况说明',
          tip: '',
          value: 'explain',
          content: '',
          length: 200,
          must: false,
          test: '',
          type: 6, // textarea
        },
      ],
    },
    {
      title: '信息特征',
      item: [
        {
          text: '体态',
          tip: '体态为必填项',
          value: 'posture',
          content: ['瘦', '中等', '胖'],
          must: true,
          test: '',
          type: 3,
        },
        {
          text: '头发曲直',
          tip: '头发曲直为必填项',
          value: 'hair_curly',
          content: ['无', '直发', '卷发'],
          must: true,
          test: '',
          type: 3,
        },
        {
          text: '头发颜色',
          tip: '头发颜色为必填项',
          value: 'hair_color',
          content: ['无', '黑', '白', '花白', '染色'],
          must: true,
          test: '',
          type: 3,
        },
        {
          text: '血型',
          tip: '',
          value: 'blood',
          content: ['A型', 'B型', 'AB型', 'O型'],
          must: false,
          test: '',
          type: 3,
        },
      ],
    },
    {
      title: '身体残疾',
      item: [
        {
          text: '有无残疾',
          tip: '有无残疾为必填项',
          value: 'body_disability',
          content: ['有', '无'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '胎记',
      item: [
        {
          text: '有无胎记',
          tip: '有无胎记为必填项',
          value: 'birthmark',
          content: ['有', '无'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '纹身',
      item: [
        {
          text: '有无纹身',
          tip: '有无纹身为必填项',
          value: 'tattoo',
          content: ['有', '无'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '肢体残疾',
      item: [
        {
          text: '有无肢体残疾',
          tip: '有无肢体残疾为必填项',
          value: 'limbs_disability',
          content: ['有', '无'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '智力残疾',
      item: [
        {
          text: '有无智力残疾',
          tip: '有无智力残疾为必填项',
          value: 'intelligence_disability',
          content: ['有', '无'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '精神状态',
      item: [
        {
          text: '精神状态',
          tip: '精神状态为必填项',
          value: 'mentality',
          content: ['异常', '正常'],
          must: true,
          test: '',
          type: 4,
        },
      ],
    },
    {
      title: '联系信息',
      item: [
        {
          text: '联系人/联系机构',
          tip: '联系人/联系机构为必填项',
          value: 'contacts',
          content: '',
          must: true,
          test: '',
          length: 100,
          type: 2,
        },
        {
          text: '联系电话',
          tip: '联系电话为必填项',
          value: 'phone',
          content: '',
          must: true,
          test: 'number',
          length: 20,
          type: 2,
        },
        {
          text: '联系地址',
          tip: '联系地址为必填项',
          value: 'contacts_address',
          content: '',
          must: false,
          test: '',
          length: 100,
          type: 6,
        },
      ],
    },
  ];
  areaList = {
    province_list: {},
    city_list: {},
    county_list: {},
  };

  async created() {
    if (isWeiXin() && !localStorage.getItem('unionid')) {
      WechatLogin();
    } else if (
      window.udid &&
      (window.gettoken() === 'null' || !window.gettoken())
    ) {
      inAppAlertLogin();
    } else if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游新闻APP打开');
      setTimeout(() => {
        this.$router.push('home');
      }, 1500);
    }
    const res: any = await getNation();
    Object.keys(res.data).map((item: string) => {
      this.info[0].item[8].content.push(res.data[item]);
    });
    const province: any = await getRegion('1');
    this.areaList.province_list = province.data;
    const city: any = await getRegion('2');
    this.areaList.city_list = city.data;
    const county: any = await getRegion('3');
    this.areaList.county_list = county.data;
  }
  login() {
    if (isWeiXin() && !localStorage.getItem('unionid')) {
      WechatLogin();
    } else if (
      window.udid &&
      (window.gettoken() === 'null' || !window.gettoken())
    ) {
      inAppAlertLogin();
    } else if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游新闻APP打开');
      setTimeout(() => {
        this.$router.push('home');
      }, 1500);
    }
  }
  getData(data: any) {
    this.imgUrl = data;
    this.submitInfo.cover = this.imgUrl.join('|');
  }
  getIndex(index: number) {
    this.imgUrl.splice(index, 1);
  }
  showPicker(data: any) {
    if (data.value === 'nations') {
      this.nation = true;
    } else {
      this.nation = false;
    }
    this.columns = data.content;
    this.show = true;
    this.value = data.value;
  }
  onConfirm(value: any, index: any) {
    this.submitInfo[this.value] = value;
    if (this.nation) {
      this.submitInfo.nation = index + 1; // 民族id
    }
    this.show = false;
  }
  onChange(picker: any, value: any, index: any) {
    this.submitInfo[this.value] = value;
  }
  changeDate(infoItem: any) {
    this.showDate = true;
    this.dateValue = infoItem.value;
  }
  onConfirmDate(value: any, index: any) {
    this.submitInfo[this.dateValue] = moment(value).format('YYYY-MM-DD');
    this.showDate = false;
  }

  confirmArea(value: any, index: any) {
    this.area = value[0].name + ',' + value[1].name + ',' + value[2].name;
    this.submitInfo.residence =
      value[0].code + ',' + value[1].code + ',' + value[2].code;
    this.areaBoolen = false;
  }
  async save() {
    let arr: any = [];
    this.info.map((item: any) => {
      arr = [...arr, ...item.item];
    });
    for (const val of arr) {
      if (
        val.must &&
        !this.submitInfo[val.value] &&
        this.submitInfo[val.value] !== 0
      ) {
        Toast(`${val.tip}`);
        return false;
      }
    }

    this.submitInfo.unionid = localStorage.getItem('unionid');
    this.submitInfo.appkey = window.appkey;
    this.submitInfo.udid = window.udid;
    this.submitInfo.token = window.gettoken();
    const res: any = await save(this.submitInfo);
    if (res.code === 200) {
      Toast(`${res.msg}`);
      setTimeout(() => {
        this.$router.go(0);
      }, 1500);
    }
  }
}
